import React from 'react';
import { getInstitutionsByCountries } from '@modules';
import { Institution } from '@types';

export const useInstitutionsByCountries = (institutions: Institution[] = [], selectedCountry?: string) => {
  const institutionsByCountries = React.useMemo(() => getInstitutionsByCountries(institutions, selectedCountry), [institutions, selectedCountry]);

  return institutionsByCountries;
};
